// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// あなたのFirebase設定
const firebaseConfig = {
  apiKey: "AIzaSyACPpxQ-_XYXZZCgA9kaO1cKxRsIRbkzJc",
  authDomain: "zaiko-bdad6.firebaseapp.com",
  projectId: "zaiko-bdad6",
  storageBucket: "zaiko-bdad6.firebasestorage.app",
  messagingSenderId: "363006335274",
  appId: "1:363006335274:web:ac0026ed5850de4df76653",
  measurementId: "G-QM9Q8BNC7F"
};

// Firebaseを初期化
const app = initializeApp(firebaseConfig);

// Firestore（データベース）を使えるようにする
export const db = getFirestore(app);
